import Vue from 'vue';
import accountService from './../account';
import store from './../../store';

const LOGIN_URL = '/api/v1/Auth';

// When the request succeeds
const success = (response) => {
  store.dispatch('login', response.data);
  if (store.state.auth.managed_sps.length === 0) {
    // TODO: Put up error saying not authorized to manage any customer accounts
    Vue.router.push({
      name: 'login.index',
    });
    return;
  }
  accountService.find();
  if (store.state.auth.selected_sp && store.state.auth.selected_sp.sp_id) {
    Vue.router.push({
      name: 'home.index',
    });
  } else {
    Vue.router.push({
      name: 'login.select',
    });
  }
};

// When the request fails
const failed = () => {
};

export default (user) => {
  const axiosOptions = {
    timeout: 3000,
    headers: { 'X-Auth-Token': '' },
    maxRedirects: 0,
    withCredentials: false,
  };
  const creds = {
    sp_id: 123,
    email: user.email,
    password: user.password,
  };
  Vue.$http.post(LOGIN_URL, creds, axiosOptions)
   .then((response) => {
     success(response);
   })
   .catch((error) => {
     failed(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/auth/login.js